import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
// Api
import { TWITTER_AUTH } from 'api/auth/mutations';
// Types
import { TwitterAuth, TwitterAuthVariables } from 'api/auth/types/TwitterAuth';
// Hooks
import { useSocialAuth } from 'hooks';
// Ui
import FourDotsLoader from 'ui/FourDotsLoader/FourDotsLoader';

const TwitterSdkWatcher = (): null | JSX.Element => {
  const { handleSocialAuthResponse, handleSocialAuthError } = useSocialAuth();
  const { query } = useRouter();
  const [loading, setLoading] = useState<boolean>(false);

  const [twitterAuth] = useMutation<TwitterAuth, TwitterAuthVariables>(
    TWITTER_AUTH
  );
  const oauthToken = query.oauth_token as string;
  const oauthVerifier = query.oauth_verifier as string;

  useEffect(() => {
    if (oauthToken && oauthVerifier) {
      setLoading(true);

      const login = async (): Promise<void> => {
        try {
          const { data } = await twitterAuth({
            variables: {
              input: {
                oauth_token: oauthToken,
                oauth_verifier: oauthVerifier,
              },
            },
          });

          if (data?.twitterAuth) {
            await handleSocialAuthResponse(data.twitterAuth);
          }
        } catch (error) {
          handleSocialAuthError(error, 'Twitter');
        }

        setLoading(false);
      };

      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthToken, oauthVerifier]);

  if (loading) {
    return <FourDotsLoader />;
  }

  return null;
};

export default TwitterSdkWatcher;
